export const Endpoints = {
    Activity: {
        GetAll: '/api/v1/activity/',
        Create: '/api/study/activity/session/create/',
        CriteriaEvaluation: '/api/v1/activity/criteria/evaluate/',
        SubmitSurvey: '/api/study/survey/session/response/submit/',
    },
    Auth: {
        Token: '/api/v1/auth/token/',
    },
    Chat: {
        Rooms: '/api/v1/chat/rooms/',
    },
    DataSource: {
        Root: '/api/v1/data_source/',
        Options: '/api/v1/data_source/options/',
    },
    Log: '/api/study/log/create/',
    Participation: '/api/v1/participation/',
    ParticipantHistoryReport: '/api/study/ph/create/',
    StudyRegistration: {
        Read: '/api/study/registration/',
        Join: '/api/study/registration/create/',
    },
    Study: {
        Info: '/api/study/info/register/',
        Quit: '/api/study/quit/',
    },
    User: {
        Root: '/api/v1/user/',
        DataSourceAccessStatus: '/api/study/user/cds/access/status/',
        GrantDataSourceAccess: '/api/study/user/cds/access/grant/',
        RevokeDataSourceAccess: '/api/study/user/cds/access/revoke/',
        Avatar: '/api/v1/user/avatar/',
        Email: '/api/v1/user/email/',
        Password: '/api/v1/user/password/',
        Phone: '/api/v1/user/phone/',
    },
    Registration: {
        ResetParticipationByParticipant: '/api/v1/registration/reset_participation_by_participant/',
        ResetParticipationByResearcher: '/api/v1/registration/reset_participation_by_researcher/',
    },
};
